@if (isInitialized) {
  <oe-navigation-view>
    <ion-buttons header class="ion-justify-content-center">
      <div #ref><ng-content select="[custom-pickdate]"></ng-content></div>
      @if (!ref.children.length) {
        <pickdate></pickdate>
      }
    </ion-buttons>
    <common-grid-details-external-limitation-chart [isOnlyChart]="true"></common-grid-details-external-limitation-chart>
  </oe-navigation-view>
}
